import { type EffectCallback, useEffect } from "react";

export const useFocusEffect = (effect: EffectCallback) => {
  // TODO: Check whether this is a valid use of useEffect - Biome complains
  // that: Outer scope values aren't valid dependencies because mutating them
  // doesn't re-render the component.

  useEffect(effect, [effect]);
};
